var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87469 0H17.5589C18.3964 0 19.1997 0.332706 19.7919 0.924926C20.3841 1.51715 20.7168 2.32037 20.7168 3.15789V12.6316C20.7168 13.4691 20.3841 14.2723 19.7919 14.8645C19.1997 15.4568 18.3964 15.7895 17.5589 15.7895H3.87469C3.03717 15.7895 2.23394 15.4568 1.64172 14.8645C1.0495 14.2723 0.716797 13.4691 0.716797 12.6316V3.15789C0.716797 2.32037 1.0495 1.51715 1.64172 0.924926C2.23394 0.332706 3.03717 0 3.87469 0ZM3.87469 1.05263C3.38076 1.0518 2.90243 1.22554 2.52417 1.54316L10.7168 6.86316L18.9094 1.54316C18.5311 1.2257 18.0528 1.05198 17.5589 1.05263H3.87469ZM10.7168 8.1179L1.91048 2.4C1.8171 2.64176 1.76928 2.89872 1.76943 3.15789V12.6316C1.76943 13.1899 1.99123 13.7254 2.38605 14.1202C2.78086 14.515 3.31634 14.7368 3.87469 14.7368H17.5589C18.1173 14.7368 18.6527 14.515 19.0475 14.1202C19.4424 13.7254 19.6642 13.1899 19.6642 12.6316V3.15789C19.6642 2.89053 19.6147 2.63474 19.5231 2.4L10.7168 8.11684V8.1179Z",
    fill: "#A1A6B1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.4b10cc73.svg";
export { ForwardRef as ReactComponent };